(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AprovacaomapaDialogController', AprovacaomapaDialogController);

    AprovacaomapaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Aprovacaomapa', 'Safra', 'Atributo'];

    function AprovacaomapaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Aprovacaomapa, Safra, Atributo) {
        var vm = this;

        vm.aprovacaomapa = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.safras = Safra.querySafraIdNome(
            {size: 1000, sort:"nomesafra,asc"}
        );
        vm.atributos = Atributo.query({
            size:1000, sort:"nomeatributo,asc"
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.aprovacaomapa.id !== null) {
                console.log(vm.mapaimagem);
                vm.aprovacaomapa.data.setHours(0);
                Aprovacaomapa.update(vm.aprovacaomapa, onSaveSuccess, onSaveError);
            } else {
                Aprovacaomapa.save(vm.aprovacaomapa, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:aprovacaomapaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImagem = function ($file, aprovacaomapa) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        aprovacaomapa.imagem = base64Data;
                        aprovacaomapa.imagemContentType = $file.type;
                    });
                });
            }
        };

        vm.setImagempequena = function ($file, aprovacaomapa) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        aprovacaomapa.imagempequena = base64Data;
                        aprovacaomapa.imagempequenaContentType = $file.type;
                    });
                });
            }
        };

        vm.setShapefile = function ($file, mapaimagem) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        mapaimagem.shapefile = base64Data;
                        mapaimagem.shapefileContentType = $file.type;
                    });
                });
            }
        };
        
        vm.setWKT = function ($file, mapaimagem) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        mapaimagem.wkt = base64Data;
                        mapaimagem.wktContentType = $file.type;
                    });
                });
            }
        };
        
        vm.setCSV = function ($file, mapaimagem) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        mapaimagem.csv = base64Data;
                        mapaimagem.csvContentType = $file.type;
                    });
                });
            }
        };

        vm.datePickerOpenStatus.data = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
